/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { isRtl as r } from "./utils/index.mjs";
import { tableKeyboardNavigationHeaderAttributes as s } from "../navigation/constants.mjs";
import { classNames as o } from "@progress/kendo-react-common";
class m extends t.Component {
  constructor() {
    super(...arguments), this.element = null;
  }
  componentDidMount() {
    const { columnResize: e } = this.props;
    e && e.resizable && e.setIsRtl(r(this.element));
  }
  render() {
    return /* @__PURE__ */ t.createElement(
      "thead",
      {
        className: o("k-table-thead k-grid-header", {
          "k-grid-draggable-header": this.props.reorderable
        }),
        role: "presentation",
        ref: (e) => this.element = e,
        ...s
      },
      this.props.headerRow,
      this.props.filterRow
    );
  }
}
export {
  m as Header
};
